<div class="widget-selector-flyout">
  <div class="flyout-headline-row">
    <div class="headline-title">{{ titleKey | translate }}</div>
    <div class="header-close-icon">
      <mat-icon class="close-icon" (click)="cancel()">close</mat-icon>
    </div>
  </div>

  <div class="flyout-body">
    @if (loading) {
      <mat-spinner diameter="36" class="loading-spinner"></mat-spinner>
    }
    @if (!loading) {
      <app-widget-selector-menu
        [items]="items"
        [multiple]="true"
        [counts]="openCounts"
        [formControl]="selectedControl"
        [placeholder]="'visits.criteriaProperties.chooseFromList' | translate"></app-widget-selector-menu>
    }
  </div>

  <div class="flyout-footer">
    <button mat-stroked-button class="secondary-button" type="button" (click)="cancel()">
      {{ "generic.cancel" | translate }}
    </button>
    <button mat-stroked-button class="primary-button" type="button" [disabled]="!selectedControl.value?.length && !initialSelectedIds.length" (click)="apply()">
      {{ "generic.apply" | translate }}
    </button>
  </div>
</div>
